<template>
  <!-- Transition added to avoid the flickering of multiple API call -->
  <transition name="fade">
    <div class="loading-wrapper">
      <img
        src="../../assets/images/spinner.svg"
        alt="Loading" >
      <span><slot/></span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
  components: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.loading-wrapper {
  background-color: rgba(255, 255, 255, 0.7);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 5000;
  top: 0;
  text-align: center;
  img {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-leave-to {
  opacity: 0.99;
}
</style>
